import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import LiveShapeStepConfigEditorPane from 'pipelines/generalized-step-config-editor/LiveShapeStepConfigEditorPane';
import {getDataFrameInfosFromInputDataFrames} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {stepIsConfigEditorSupported} from 'pipelines/generalized-step-config-editor/stepTypeIsConfigEditorSupported';
import {stepTypeHasSavedShape} from 'pipelines/generalized-step-config-editor/useLiveStepShape';
import useScratchPlateMappableColumns from 'pipelines/hooks/useScratchPlateMappableColumns';
import {PipelineStep} from 'pipelines/PipelineTypes';
import {getInputStepDatasRecord} from 'pipelines/StepDataUtils';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export default function TransformPopoverContents({step}: {step: PipelineStep}): JSX.Element {
  assert(stepIsConfigEditorSupported(step), 'Unsupported step for transform popover');
  assert(step.config != null, 'Expected non-null config');

  const scratchPlateColumns = useScratchPlateMappableColumns(step);
  const plateInputDataName = Object.keys(getInputStepDatasRecord(step, PipelineStepDataKind.PLATE)).at(0);
  const datasetInfos = getDataFrameInfosFromInputDataFrames(
    getInputStepDatasRecord(step, PipelineStepDataKind.DATASET)
  );
  const dataFramesInfos =
    plateInputDataName == null
      ? datasetInfos
      : {
          ...datasetInfos,
          [plateInputDataName]: [{dataFrameSpec: {name: plateInputDataName, columns: scratchPlateColumns}}],
        };

  return (
    <div className={css(styles.wrapper)}>
      <LiveShapeStepConfigEditorPane
        stepType={step.stepType}
        stepVersion={step.stepVersion}
        config={step.config}
        setConfig={noop}
        readOnly={true}
        dataFramesInfos={dataFramesInfos}
        clientStateId={step.id}
        // Other step types' shapes for a step can come with a config to match, which this read-only preview
        // doesn't keep.
        stepId={stepTypeHasSavedShape(step.stepType, step.stepVersion) ? step.id : undefined}
        connectedInputNames={step.incomingEdges.map((edge) => edge.toStepData.name)}
      />
    </div>
  );
}

const PADDING = 10;

const styles = StyleSheet.create({
  wrapper: {
    padding: PADDING,
    margin: PADDING,
    width: MAX_POPOVER_WIDTH - PADDING,
    maxHeight: MAX_POPOVER_HEIGHT,
  },
});
